import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useNearbyRetailersQuery } from './nearbyRetailers.generated';
import { useReatailersQueryQuery } from './retailers.generated';
import { RetailerCarousel } from '@/components/RetailerCarousel';
import { ShortRetailerInfo } from '@/components/ShortRetailerInfo';
import { Retailer } from '@/types';
import JoinRetailerModal from './components/JoinRetailerModal';

const FarmersHomePage = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRetailer, setSelectedRetailer] = useState<Retailer>();
  const [{ data: mainRetailers }] = useReatailersQueryQuery();
  const [{ data: nearbyRetailers }] = useNearbyRetailersQuery();

  const handleJoinRetailerClick = (retailer: Retailer) => {
    setSelectedRetailer(retailer);
    setIsModalOpen(true);
  };

  return (
    <div className="w-full max-w-[106rem] mx-auto py-6-0">
      <JoinRetailerModal
        isOpen={isModalOpen}
        setIsOpen={() => setIsModalOpen(false)}
        retailer={selectedRetailer as Retailer}
      />
      {(mainRetailers?.retailers?.length ?? 0) > 0 && (
        <>
          <p
            role="heading"
            className="font-bd text-3-0 md:text-2-4 text-primary-black mb-2-0"
          >
            {i18n.t('farmers_homepage.title')}
          </p>
          {/* retailers carousel */}
          <RetailerCarousel
            retailers={mainRetailers?.retailers as Retailer[]}
          />
          {/* other retailers */}
          <div className="cursor-pointer grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2-0 my-8-0">
            {mainRetailers?.retailers.map((retailer) => (
              <div
                key={retailer?.id}
                onClick={() => navigate('/' + retailer?.id)}
              >
                <ShortRetailerInfo retailer={retailer as Retailer} />
              </div>
            ))}
          </div>
        </>
      )}

      {/* nearby retailers */}
      {nearbyRetailers?.retailers && (
        <p className="font-bd text-3-0 md:text-2-4 text-primary-black mb-2-5">
          {i18n.t('farmers_homepage.subTitle')}
        </p>
      )}
      <div className="cursor-pointer grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2-0">
        {nearbyRetailers?.retailers.map((retailer) => (
          <div
            key={retailer?.id}
            onClick={() => handleJoinRetailerClick(retailer as Retailer)}
          >
            <ShortRetailerInfo retailer={retailer as Retailer} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default FarmersHomePage;
